if (isBrowser) {

    //---------------Mobile Javascript-----------------------------
    if (/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        window.isMobile = true;
    }
//------------------------------------------------------
//    var veeValidateMixin = {
//        watch: {
//            'errors.items': function (vErros) {
//                var _this = this;
//                vErros.forEach(function (error) {
//                    if ($(_this.$el.querySelectorAll(".element_" + error.field)).length == 0) {
//                        var $element = $(_this.$el.querySelectorAll("[name='" + error.field + "']"));
//                        var position = $element.position();
//                        $('<div onclick="$(this).remove()" style="left:auto;top:' + (position.top - 25) + 'px" class="form_error_area2 element_' + error.field + '"><span><i class="mdi mdi-asterisk"></i></span><span> ' + error.msg + '</span></div>').insertAfter($element[0]);
//                    }
//                });
//                Object.entries(this.fields).forEach(([field_name, field]) => {
//                    if (field.valid) {
//                        var $element = $(_this.$el.querySelector(".element_" + field_name));
//                        $element.remove();
//                }
//                });
//            }
//        }
//    };
//------------------------------------------------------
    window.getUserFromStorage = function () {
        var encryptedUser = localStorage.getItem('session');
        if (encryptedUser) {
            try {
                return JSON.parse(decodeURIComponent(escape(window.atob(encryptedUser))));
                //            return JSON.parse(atob(encryptedUser));
            } catch (err) {
                localStorage.removeItem('session');
            }
        } else {
            return "";
        }
    };

    $(document).ready(function () {

        window.processing_data = false;
        window.onbeforeunload = function () {
            if (window.processing_data) {
                return "Changes you made may not be saved.";
            }
        };
        //-----------------------------------------
    });
//--------------------Set Textarea & Input text direction------------------------------
    $("*").on('click keydown', "textarea,input,[type='number']", function (event) {
        $("textarea,input").attr("dir", "auto");
        $("[type='number']").attr("min", "0");
    });
//--------------------stoping user to enter manual date in datepicker------------------------
    $(document).on('keydown', '.vdp-datepicker input', function (event) {
        return false;
    });

    function elementLoadedCallback(el, cb, time) {
        time = time || 1000;
        if ($(el).length) {
// Element is now loaded.
            cb($(el));
        } else {
// Repeat every 500ms.
            setTimeout(function () {
                elementLoaded(el, cb, time)
            }, time);
        }
    }
    ;
    function makeThread(func, time, try_counter) {
        time = time || 1000;
        try_counter = try_counter || 5;
        setTimeout(function () {
            if (try_counter > 0 && (((typeof func == 'function') ? func() : eval(func)) === false)) {
                makeThread(func, time, try_counter - 1);
            }
        }, time);
        if (try_counter == 0)
            console.log(func + " Max Tries Expired");
    }

    function downloadFile(url, fileName) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = function () {
            var urlCreator = window.URL || window.webkitURL;
            var imageUrl = urlCreator.createObjectURL(this.response);
            var tag = document.createElement('a');
            tag.href = imageUrl;
            tag.download = fileName || url.split('/').pop().split('#')[0].split('?')[0];
            document.body.appendChild(tag);
            tag.click();
            document.body.removeChild(tag);
        }
        xhr.send();
    }

//-----------------------------------Toggle Menu------------------
//*************How Do You Feel Menu************
    $(document).ready(function () {
        $("body").on('click', '.feeling_menu_trigger', function (event) {
            $(".feeling_menu_container").toggle();
        });
        $("body").on('click', function (e) {
            var ignoreContainer = $(".feeling_menu_trigger"); //you can add .feeling_menu_container class if you want to keep container on when user click inside of container e.g  $(".feeling_menu_trigger,.feeling_menu_container")
            if (!(ignoreContainer.is(e.target) || ignoreContainer.has(e.target).length)) {
                $(".feeling_menu_container").hide();
            }
        });
    });

}